// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gy-0";